<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="700px">
    <v-card style="min-width:400px">
      <v-card-title class="headline pb-5">Invoice Sent History</v-card-title>
      <v-card-text>
        <v-row v-if="activityData">
          <v-col class="pb-0" cols="12" sm="12" md="12" lg="12">
            <v-btn color="success" small class="mb-2" v-if="showEditActions" @click="updateActivity()">Save Changes</v-btn>
            <v-btn color="warning" small class="mb-2" v-if="showEditActions" @click="cancelEdit()">Cancel</v-btn>
          </v-col>
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date Time</th>
                    <!-- <th class="text-left">Start Month</th>
                    <th class="text-left">End Month</th> -->
                    <th class="text-left">Invoice Sent</th>
                    <th class="text-left">Remark</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(activity, index) of activityData" :key="index">
                    <td>{{ formatTime(activity.timestamp) }}</td>
                    <!-- <td>{{ formatMonth(activity.startMonth) }}</td>
                    <td>{{ formatMonth(activity.endMonth) }}</td> -->
                    <td>${{ activity.amount | thousandSeprator }}</td>
                    <td>
                      <div @click="openEditItem(activity, 'remarks', 'activityData')" v-if="activity.remarksEdit === false">
                        {{ activity.remarks || '' }}
                        <v-icon class="cursor-pointer" color="warning" x-small>edit</v-icon>
                      </div>
                      <div v-else>
                        <div class="mt-2">
                          <v-textarea
                            v-model="activity.remarks"
                            placeholder=""
                            outlined
                            dense
                            rows="2"
                          ></v-textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Loading from 'vue-loading-overlay';
import moment from 'moment'
import DataTableMixin from '@/mixins/DataTableMixin'
export default {
  name: 'InvoiceSentActivityModal',
  mixins: [DataTableMixin],
  components: { Loading },
  data() {
    return {
      activityData: [],
      isLoading: false,
      showEditActions: false
    };
  },
  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value(value) {
      if (value) {
        if (!this.data) return
        this.activityData = Object.assign([], this.data)
      }
    }
  },
  methods: {
    updateActivity() {
      this.$emit('updateActivityData', this.activityData)
      let vm = this
      setTimeout(() => {
        vm.cancelEdit()
      }, 1000)
    },
    cancelEdit() {
      this.activityData = this.activityData.map(act => {
        act.remarksEdit = false
        return act
      })
      this.showEditActions = false
    },
    formatTime(value) {
      return moment(value).format('DD-MM-YYYY hh:mm:ss')
    },
    formatMonth(value) {
      return moment(value).format('MMM YYYY');
    },
    close() {
      this.$emit('input');
    }
  }
};
</script>



// WEBPACK FOOTER //
// InvoiceSentActivityModal.vue?48e4fe7a